import httpClient from './httpClient';

export const NAVIGATION_MENU_ENDPOINT = '/backoffice/categories/navigation-menu';

export const getNavigationMenusAPI = (params = {}) => httpClient.get(NAVIGATION_MENU_ENDPOINT, { params });
export const getNavigationMenuAPI = (id) => httpClient.get(`${NAVIGATION_MENU_ENDPOINT}/${id}`);
export const postNavigationMenuAPI = (body = {}) => httpClient.post(NAVIGATION_MENU_ENDPOINT, body);
export const updateNavigationMenuAPI = (id, body = {}) => httpClient.put(`${NAVIGATION_MENU_ENDPOINT}/${id}`, body);
export const deleteNavigationMenuAPI = (id) => httpClient.delete(`${NAVIGATION_MENU_ENDPOINT}/${id}`);